var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinEq8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_895_5831)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_895_5831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 67.5C17.9419 59.7919 11.1789 52.6369 6.70645 46.0263C2.23403 39.4156 0 33.3015 0 27.675C0 19.2353 2.71306 12.5158 8.14355 7.50774C13.5697 2.50403 19.8581 0 27 0C34.1419 0 40.4303 2.50403 45.8565 7.50774C51.2826 12.5158 54 19.2353 54 27.675C54 33.3015 51.766 39.4156 47.2935 46.0263C42.8211 52.6369 36.0581 59.7919 27 67.5V67.5Z",
    fill: "#2E197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 27.675C0.5 19.353 3.16975 12.7748 8.4825 7.87531L8.48252 7.8753C13.8197 2.95359 19.9883 0.5 27 0.5C34.0117 0.5 40.1802 2.95355 45.5173 7.87517C50.826 12.7748 53.5 19.3532 53.5 27.675C53.5 33.1679 51.3183 39.185 46.8794 45.7461C42.4947 52.2272 35.8757 59.2569 27 66.8429C18.1243 59.2569 11.5053 52.2272 7.12058 45.7461C2.68166 39.185 0.5 33.1679 0.5 27.675Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 48.87C39.3742 48.87 49.4055 38.8387 49.4055 26.4644C49.4055 14.0901 39.3742 4.05872 26.9999 4.05872C14.6256 4.05872 4.59424 14.0901 4.59424 26.4644C4.59424 38.8387 14.6256 48.87 26.9999 48.87Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.385 24.5266C32.5075 24.5266 31.7594 24.2166 31.1406 23.5966C30.5219 22.9767 30.2125 22.2271 30.2125 21.3478C30.2125 20.4686 30.5219 19.719 31.1406 19.099C31.7594 18.4791 32.5075 18.1691 33.385 18.1691C34.2625 18.1691 35.0106 18.4791 35.6294 19.099C36.2481 19.719 36.5575 20.4686 36.5575 21.3478C36.5575 22.2271 36.2481 22.9767 35.6294 23.5966C35.0106 24.2166 34.2625 24.5266 33.385 24.5266ZM26.77 32V30.2754C26.77 29.6892 26.8938 29.1876 27.1413 28.7705C27.3888 28.3535 27.7375 28.0322 28.1875 27.8068C29.02 27.3784 29.8638 27.0628 30.7188 26.8599C31.5738 26.657 32.4625 26.5556 33.385 26.5556C34.3075 26.5556 35.1963 26.6514 36.0513 26.843C36.9063 27.0346 37.75 27.3559 38.5825 27.8068C39.0325 28.0097 39.3813 28.3253 39.6288 28.7536C39.8763 29.182 40 29.6892 40 30.2754V32H26.77ZM23.8 21.1449C22.315 21.1449 21.1 20.6715 20.155 19.7246C19.21 18.7778 18.7375 17.5604 18.7375 16.0725C18.7375 14.5845 19.21 13.3672 20.155 12.4203C21.1 11.4734 22.315 11 23.8 11C25.285 11 26.5 11.4734 27.445 12.4203C28.39 13.3672 28.8625 14.5845 28.8625 16.0725C28.8625 17.5604 28.39 18.7778 27.445 19.7246C26.5 20.6715 25.285 21.1449 23.8 21.1449V21.1449ZM13 32V28.8213C13 28.0548 13.1912 27.3502 13.5737 26.7077C13.9562 26.0652 14.53 25.5749 15.295 25.2367C16.8025 24.5604 18.2481 24.0531 19.6319 23.715C21.0156 23.3768 22.405 23.2077 23.8 23.2077C24.52 23.2077 25.1613 23.2415 25.7238 23.3092C26.2863 23.3768 26.8937 23.4783 27.5462 23.6135L25.825 25.3382C25.375 25.7891 25.0825 26.2625 24.9475 26.7585C24.8125 27.2544 24.745 28.3253 24.745 29.971V32H13Z",
    fill: "#516274"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_895_5831",
    x: -4,
    y: 0,
    width: 62,
    height: 75.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_895_5831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_895_5831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_895_5831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 67.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEq8);
export default __webpack_public_path__ + "static/media/pin-eq-8.e5be899cd61f83f89276966ee91bc8a0.svg";
export { ForwardRef as ReactComponent };